import { render, staticRenderFns } from "./OtherForm.vue?vue&type=template&id=362d31d0&scoped=true"
import script from "./OtherForm.vue?vue&type=script&lang=js"
export * from "./OtherForm.vue?vue&type=script&lang=js"
import style0 from "./OtherForm.vue?vue&type=style&index=0&id=362d31d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362d31d0",
  null
  
)

export default component.exports